<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents" v-if="!isRendering">
      <h1 class="l-pageTitle"><img src="@/assets/img/common/icon-nav3_blue.svg" alt="">診断コースマスタ</h1>
      <div class="l-btn-createnew_pos">
        <div class="btn-create-new_wh" @click="goInput('')" :disabled="isProcessing"><a>新規作成</a></div>
      </div>
      <div class="l-contentsBox">
        <table class="table-base audit-table table-select mt-30">
          <colgroup>
            <col style="width: 100px;">
            <col style="width: 150px;">
            <col>
          </colgroup>
          <thead>
            <tr>
              <th>診断コース名</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="diagCourse in diagCourses" :key="diagCourse.diagCourseId">
              <td @click="goEdit(diagCourse.diagCourseId)">{{ diagCourse.courseName }}</td>
              <td>
                <div class="btn-delete js-btn-delete" @click="deleteDiagCourse(diagCourse.diagCourseId)" :disabled="isProcessing"><a>削除</a></div>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          :pageInfo="pageInfo"
          @change-page="emitChangePage">
        </pagination>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import Pagination from '@/components/parts/common/Pagination.vue';

export default {
  components: {
    Loading,
    Pagination,
  },
  data() {
    return {
      isProcessing: false,
      isRendering: false,
      isSearch: false,
      pageInfo: {},
      diagCourses: [],
      searchForm: {
        verId: null,
        deleteFlg: false,
      },
      diagVerList: []
    }
  },
  created: async function() {
    this.isProcessing = true;
    this.isRendering = true;

    await this.getDiagCourseList(1);
    await this.getDiagVerList();
    this.$nextTick(() => {
      this.isRendering = false;
      this.isProcessing = false;
    });
  },
  methods: {
    async emitChangePage(page) {
      this.isProcessing = true;
      this.isRendering = true;
      await this.getDiagCourseList(page)
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });
    },
    async search() {
      this.isProcessing = true;
      this.isRendering = true;
      await this.getDiagCourseList(1)
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });
    },
    showSearch(value) {
      this.isSearch = value;
    },
    async getDiagCourseList(page) {
      let res = await this.$axios.post('/ld/api/master/diagCourse/getDiagCourseList', {
        page: page,
        verId: this.searchForm.verId,
        deleteFlg: this.searchForm.deleteFlg
      });
      if (res) {
        this.diagCourses = res.data.diagCourses.data;
        this.pageInfo = {
          currentPage: res.data.diagCourses.currentPage,
          lastPage: res.data.diagCourses.last_page,
          total: res.data.diagCourses.total,
          from: res.data.diagCourses.from,
          to: res.data.diagCourses.to,
        }
        this.isSearch = false;
      }
    },
    async getDiagVerList() {
      let res = await this.$axios.post('/ld/api/master/diag/getDiagVerList', {});
      if (res) {
        this.diagVerList = res.data.diagVerList;
      }
    },
    goInput() {
      this.$store.dispatch('master/setDiagCourseId', null);
      this.$router.push({ name: 'diag-course-new' });
    },
    goEdit(diagCourseId) {
      this.$store.dispatch('master/setDiagCourseId', diagCourseId);
      this.$router.push({ name: 'diag-course-edit' } );
    },
    async deleteDiagCourse(diagCourseId) {
      const ans = confirm('削除しますか？');
      if (ans) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/master/diagCourse/delete', {
          diagCourseId: diagCourseId,
        });
        if (res) {
          this.$toast.info('削除しました');
          await this.getDiagCourseList(1);
        }
        this.isProcessing = false;
      }
    }
  },
}
</script>

<style scoped>
.diagcoursesearch-fade-enter-active {
  transition: height .1s ease-in-out;
}
.diagcoursesearch-fade-leave-active {
  transition: height .1s ease-in-out;
}
.diagcoursesearch-fade-enter-to, .diagcoursesearch-fade-leave {
  overflow: hidden;
}
.diagcoursesearch-fade-enter, .diagcoursesearch-fade-leave-to {
  overflow: hidden;
}
</style>
